'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moduleName = undefined;

var _mapConstants = require('utils/map-constants');

var _mapConstants2 = _interopRequireDefault(_mapConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moduleName = exports.moduleName = 'statistics';

var constants = ['PROJECTS_REORDER', 'PROJECTS_FILTER', 'SET_PROJECTS_TAB', 'RECIPIENTS_REORDER', 'RECIPIENTS_FILTER', 'SET_PERIOD_NAME', 'SET_REPORT_DATES', 'SET_PROJECT_ID', 'SET_RECIPIENT_ID', 'COVERAGE_RECIPIENTS_REORDER', 'RECIPIENT_PROJECTS_REORDER', 'SET_PROJECTS_LIST_PAGE'];

exports.default = (0, _mapConstants2.default)({ moduleName: moduleName, constants: constants });


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/statistics.js
// module id = 2231
// module chunks = 1